import CorrespondenceContactModelBase from '../_generated/modelBases/correspondence-contact-model-base';

export default class CorrespondenceContactModel extends CorrespondenceContactModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
